export default function ({ store }) {
  const autoReorderSetupVariantMonths = JSON.parse(localStorage.getItem('autoReorderSetupVariantMonths'))
  const autoReorderDaysInterval = JSON.parse(localStorage.getItem('autoReorderDaysInterval'))
  const nextOrderDate = JSON.parse(localStorage.getItem('nextOrderDate'))

  if (autoReorderSetupVariantMonths) {
    store.dispatch('order/setAutoReorderSetupVariantMonths', autoReorderSetupVariantMonths)
  }
  if (autoReorderDaysInterval) {
    store.dispatch('order/setAutoReorderDaysInterval', autoReorderDaysInterval)
  }
  if (nextOrderDate) {
    store.dispatch('order/setNextOrderDate', nextOrderDate)
  }
}
